import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { format_number } from "../../../utilities/ext-function";

const ReportChatbotInteraction = ({ selectedData }) => {
  const [expandedRow, setExpandedRow] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10; // Ubah jumlah data per halaman sesuai kebutuhan

  // Hitung total halaman
  const totalPages = Math.ceil(selectedData?.length / rowsPerPage);

  // Ambil data berdasarkan halaman saat ini
  const currentData = selectedData?.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <>
      <div className="table-responsive">
        <table className="table table-bordered table-custome">
          <thead>
            <tr className="text-white">
              <th rowSpan="2" className="text-center p-2">
                Periods
              </th>
              <th rowSpan="2" className="text-center p-2">
                Total Chat
              </th>
              <th colSpan="3" className="text-center p-2">
                Sentiments
              </th>
              <th rowSpan="2" className="text-center p-2">
                Unanswered
              </th>
              <th rowSpan="2" className="text-center p-2">
                New Users
              </th>
            </tr>
            <tr className="text-white">
              <th className="text-center bg-success p-2">Positive</th>
              <th className="text-center bg-primary p-2">Neutral</th>
              <th className="text-center bg-danger p-2">Negative</th>
            </tr>
          </thead>
          <tbody>
            {currentData.length > 0 ? (
              currentData.map((row, index) => (
                <tr key={index}>
                  <td className="p-2">
                    {moment(row.period).format("DD-MM-YYYY")}
                  </td>
                  <td className="p-2 text-end">
                    {row.chat_count ? format_number(row.chat_count) : 0}
                  </td>
                  <td className="p-2 text-success text-end">
                    {row.positive_sentiment
                      ? format_number(row.positive_sentiment)
                      : 0}
                  </td>
                  <td className="p-2 text-primary text-end">
                    {row.neutral_sentiment
                      ? format_number(row.neutral_sentiment)
                      : 0}
                  </td>
                  <td className="p-2 text-danger text-end">
                    {row.negative_sentiment
                      ? format_number(row.negative_sentiment)
                      : 0}
                  </td>
                  <td className="p-2 text-end">
                    {row.unanswered_questions
                      ? format_number(row.unanswered_questions)
                      : 0}
                  </td>
                  <td className="p-2 text-end">
                    {row.new_unique_user
                      ? format_number(row.new_unique_user)
                      : 0}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center p-2">
                  No Data
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* Pagination */}
      {totalPages > 1 && (
        <div className="d-flex justify-content-between">
          <div>
            Page {currentPage} of {totalPages}
          </div>
          <div>
            <Button
              variant="primary"
              className="btn btn-sm me-2"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              Prev
            </Button>
            <Button
              variant="primary"
              className="btn btn-sm"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              Next
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default ReportChatbotInteraction;
